import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Shipper } from 'src/apis/monolith/types';
import { Card } from 'src/components/data-display/card';
import { Stack } from 'src/components/layout/stack';
import { Heading } from 'src/components/text/heading';
import { Successful } from 'src/hooks/use-axios';
import FromShipperPage from 'src/pages/shippers/details/documents/from-shipper/page';
import { ShipperNavigationBar } from 'src/pages/shippers/details/documents/shipper-navigation-bar';
import ToShipperPage from 'src/pages/shippers/details/documents/to-shipper/page';
import { useDocuments } from 'src/pages/shippers/details/documents/use-documents';
import { usePageParams } from 'src/pages/shippers/details/documents/use-page-params';
import { useDocumentExchangeRequest } from 'src/pages/shippers/upload-documents/use-document-exchange';
import { ShipperPlatformIdsRequest } from 'src/pages/shippers/use-shipper-platform-ids';

type ShipperContractsProps = {
  shipper: Shipper;
  shipperPlatformIds: Successful<ShipperPlatformIdsRequest>;
};

export const ShipperDocuments: FC<ShipperContractsProps> = ({
  shipper,
  shipperPlatformIds,
}) => {
  const shipperRefId = shipperPlatformIds.response.data.referenceId.toString();
  const documents = useDocuments({ shipperRefId });
  const pageParams = usePageParams();
  const documentExchange = useDocumentExchangeRequest({
    neededOnPageLoad: false,
  });
  const showDocumentExchange =
    documentExchange.response && documentExchange.response.status !== 404;

  return (
    <Stack flow="column">
      <Card>
        <Stack gap={1}>
          <Stack flow="column" justifyContent="space-between">
            <Heading mode="section">Documents</Heading>
          </Stack>
          {showDocumentExchange &&
            documentExchange.response?.data?._links?.getOperatorDocumentsOutbox
              ?.href && (
              <ShipperNavigationBar shipperPlatformIds={shipperPlatformIds} />
            )}
          <Switch>
            {showDocumentExchange &&
              documentExchange.response?.data?._links
                ?.getOperatorDocumentsOutbox?.href && (
                <Route path="/dashboard/shippers/:shipperUuid/documents/to">
                  <ToShipperPage
                    operatorDocumentsOutboxLink={
                      documentExchange.response?.data._links
                        ?.getOperatorDocumentsOutbox.href
                    }
                    shipper={shipper}
                  />
                </Route>
              )}
            <Route path="/dashboard/shippers/:shipperUuid/documents/from">
              <FromShipperPage
                shipper={shipper}
                documents={documents}
                pageParams={pageParams}
                shipperPlatformIds={shipperPlatformIds}
              />
            </Route>
            <Redirect
              from="/dashboard/shippers/:shipperUuid/documents/"
              exact
              to="/dashboard/shippers/:shipperUuid/documents/from"
            />
          </Switch>
        </Stack>
      </Card>
    </Stack>
  );
};
